<div id="freshpass-benefits-container margin-xlg-64">
    <div class="container p0 clear-fix mb24 container-gallery">
        <div class="container p0">
            <div *ngIf="carouselData?.dealsInfo?.length > 0">
                <deals-carousel [carouselData]="carouselData" [logoProps]="logoProps"
                    [configObj]="configObj"></deals-carousel>
            </div>
        </div>
    </div>
</div>